'use client';

import { useEffect } from 'react';

import { bindGoogleTagManagerToConsent } from '@/lib/analytics/gtm';

interface DeferredGtmLoaderProps {
  nonce?: string;
}

/**
 * Loads gtm.js after mount. Consent Mode defaults are denied in `<head>` first;
 * the cookie banner later grants storage via `gtag('consent', 'update', …)`.
 */
export function DeferredGtmLoader({ nonce }: DeferredGtmLoaderProps) {
  useEffect(() => bindGoogleTagManagerToConsent(nonce), [nonce]);

  return null;
}
